<script lang="ts">
  import { onMount } from "svelte";
  import { createEventDispatcher } from 'svelte'
  import Indicator from "./Indicator.svelte";
  import { ExerciseData } from "../dataTypes/exerciseData"
  import type { UserExerciseData } from "../stores/userExerciseDataStore";
  import { MultipleChoiceQuiz } from "../multipleChoiceQuizzes/multipleChoiceQuiz"
  import { createQuiz } from "../multipleChoiceQuizzes/multipleChoiceQuizCreator"
  import { MultipleChoiceQuizData } from "../dataTypes/multipleChoiceQuizData";
  import { MultipleChoiceOption } from "../multipleChoiceQuizzes/multipleChoiceOption";

  import { userExerciseIDStore } from '../stores/userExerciseIDStore'
  import { userExerciseDataStore } from '../stores/userExerciseDataStore'

  export let exerciseData:ExerciseData
  // svelte-ignore unused-export-let
  export let userExerciseData:UserExerciseData; userExerciseData;

  const dispatch = createEventDispatcher<{completed:void}>()
  let options:Array<MultipleChoiceOption> = new Array<MultipleChoiceOption>()
  let wrongs:Array<boolean> = new Array<boolean>()
  let question:string
  let isSuccess:boolean|null = null
  let selectedID:string|null = null

  onMount(()=> {
    generateOptions(false)
  })

  function generateOptions(isRandomize:boolean) {
    const multipleChoiceQuiz:MultipleChoiceQuiz = createQuiz(isRandomize, exerciseData.multipleChoiceQuizData as MultipleChoiceQuizData)
    question = multipleChoiceQuiz.getQuestion();
    options = multipleChoiceQuiz.getOptions();
    wrongs.length = options.length;
    wrongs.fill(false);
    wrongs = wrongs;
  }

  function handleSubmit():void {
    isSuccess = true
    for (let index = 0; index < options.length; index++) {
      let option:MultipleChoiceOption = options[index];
      if (option.isCorrect != (option.id == selectedID)) {
        isSuccess = false;
        if (exerciseData.multipleChoiceQuizData?.parameterData.showWrongOnly && option.isCorrect) {
          wrongs[index] = false;
        }
        else {
          wrongs[index] = true;
        }
      }
      else {
        wrongs[index] = false;
      }
    }
    wrongs = wrongs;
    if (isSuccess) {
      wrongs.length = options.length;
      wrongs.fill(false);
      wrongs = wrongs;
      dispatch('completed')
    }
  }
</script>

<div class="flex flex-col items-center justify-center w-full h-full text-darkFore">
  <Indicator success={isSuccess}></Indicator>
  <form>
    <fieldset>
      <legend>{@html question}</legend>
      {#each options as option, index}
        <input name={exerciseData.multipleChoiceQuizData?.parameterData.singleSelect ? "quiz" : ""} type="radio" id={option.id} value={option.id} bind:group={selectedID}/>
        <label for={option.id} class="cursor-pointer flex flex-row items-center">
          <span class="rounded-full w-4 h-4 flex items-center justify-center outline-solarized mr-1"></span>
          {option.text}
          {#if wrongs[index]}
          {option.explanation}
          {/if}
        </label>
      {/each}
    </fieldset>
  </form>
  <div class="flex space-x-4 flex-row">
    {#if $userExerciseDataStore[$userExerciseIDStore].completed}<button on:click={()=>generateOptions(true)} class="btn-darkBackHigh">Randomize</button>{/if}
    <button on:click={handleSubmit} class="btn-darkBackHigh">Submit</button>
  </div>
</div>

<style>
  label:hover {
    @apply bg-darkBackHigh;
    @apply text-darkForeHigh;
  }

  input[type="radio"] {
    @apply opacity-0;
  }

  input[type="radio"]:checked + label span {
    @apply bg-darkFore;
  }

</style>